import { useState, useEffect } from "react";
import { showToast } from "../utils/toast";

export function useErrorRenderer() {
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (message) {
      showToast(message, { type: isError ? "error" : "success" });
    }
  }, [message, isError]);

  const resetErrorState = () => {
    setTimeout(() => {
      setMessage("");
      setIsError(false);
    }, 3000);
  };

  return [message, setMessage, isError, setIsError, resetErrorState];
}
